import { decodeJwtPayload } from './lib/jwtHelper';

const LTI_CLAIM_CUSTOM = 'https://purl.imsglobal.org/spec/lti/claim/custom';

export const getDeepLinkInfo = () => {
    const id_token = sessionStorage.getItem('lti_deep_link_id_token');
    const state = sessionStorage.getItem('lti_deep_link_state');
    return {
        isActive: !!id_token,
        id_token,
        state
    };
};

export const getLtiLaunchCanvasCourseId = () => {
    const { id_token } = getDeepLinkInfo();
    if (!id_token) return null;
    const payload = decodeJwtPayload(id_token);
    if (!payload) return null;
    const custom = payload[LTI_CLAIM_CUSTOM];
    const courseId = custom?.canvas_course_id;
    return courseId != null ? String(courseId) : null;
};

export const clearDeepLinkInfo = () => {
    sessionStorage.removeItem('lti_deep_link_id_token');
    sessionStorage.removeItem('lti_deep_link_state');
};

export const shouldUseDeepLinking = () => {
    const deepLinkInfo = getDeepLinkInfo();
    return deepLinkInfo.isActive;
};
